module.exports = __webpack_public_path__ + "img/banner2-bg.36e7244c.jpg";